




















import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import ImgFetched from "@/components/ImgFetched/ImgFetched.vue";
import { isValidVipInServicelist } from "@/utils/general_utils";

@Component({
  components: {
    ImgFetched
  }
})
export default class UserItem extends Vue {
  @Prop()
  private userInfo: any;
  private vipBindId: any = "";

  private getVipBindName() {
    const binVip = isValidVipInServicelist();
    this.vipBindId = binVip && binVip.resource && binVip.resource.user_id;
  }

  private mounted() {
    this.getVipBindName();
  }
  private activated() {
    this.getVipBindName();
  }

  private clickItem() {
    this.$emit("clickItem");
  }
}
